export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12944.123d6496.jpg";